import {Image, Integer, ValueByDevice} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {always} from 'ramda';

import {advantageCarTheme} from '../theme/advantageCarTheme';
import {bmwTheme} from '../theme/bmwTheme';
import {emilFreyTheme} from '../theme/emilFreyTheme';
import {fordTheme} from '../theme/fordTheme';
import {onlineOfferTheme} from '../theme/theme';
import {getWorkspaceFromUri} from './getWorkspaceFromUri';

export type Logo = {
  src: string;
  height: ValueByDevice<Integer>;
};
export const emilFreyLogo: Logo = {
  src: '../../assets/images/emil-frey-logo.svg',
  height: [13, 15, 20, 20],
};
export const advantageCarLogo: Logo = {
  src: '../../assets/images/advantage-cars-logo.svg',
  height: [13, 15, 20, 20],
};
export const carvagoLogo: Logo = {
  src: '../../assets/images/carvago-logo.svg',
  height: [5, 6, 7, 7],
};
export const digitalCertificate: Logo = {
  src: '../../assets/images/logo.svg',
  height: [5, 6, 7, 7],
};
export const bmwLogo: Logo = {
  src: '../../assets/images/bmw-logo.svg',
  height: [13, 15, 20, 20],
};
export const fordLogo: Logo = {
  src: '../../assets/images/ford-logo.png',
  height: [13, 15, 20, 20],
};

const {workspace} = getWorkspaceFromUri();

export function getWorkspaceCustomization() {
  const resultCustomization = match<string | undefined>(workspace)
    .with(
      Pattern.union('advantagecars', 'advantage-cars-caraudit'),
      always({
        logo: advantageCarLogo,
        isOnlineOfferLogoShown: true,
        theme: advantageCarTheme,
        companyName: 'Advantage cars',
      })
    )
    .with(
      'emil-frey',
      always({
        logo: emilFreyLogo,
        isOnlineOfferLogoShown: true,
        theme: emilFreyTheme,
        companyName: 'Emil Frey',
      })
    )

    .with(
      'carvago',
      always({
        logo: carvagoLogo,
        isOnlineOfferLogoShown: true,
        theme: onlineOfferTheme,
        companyName: 'Carvago',
      })
    )
    .with(
      Pattern.union('bmw-bonkowscy', 'demo-bmw-bonkowscy'),
      always({
        logo: bmwLogo,
        isOnlineOfferLogoShown: true,
        theme: bmwTheme,
        companyName: 'BMW',
      })
    )

    .with(
      Pattern.union(
        'autoboss',
        'automotive',
        'carrara',
        'chwalinski',
        'ciesiolka',
        'citycar',
        'demo-autoboss',
        'demo-automotive',
        'demo-carrara',
        'demo-chwalinski',
        'demo-ciesiolka',
        'demo-citycar',
        'demo-ford-pl',
        'demo-frankcars',
        'demo-germaz',
        'demo-globcarsservice',
        'demo-mhmotors',
        'demo-mirai',
        'demo-rencar',
        'demo-rewo',
        'demo-szumilas',
        'demo-wikar',
        'frankcars',
        'germaz',
        'globcarsservice',
        'mhmotors',
        'mirai',
        'rencar',
        'rewo',
        'szumilas',
        'wikar'
      ),
      always({
        logo: fordLogo,
        isOnlineOfferLogoShown: true,
        theme: fordTheme,
        companyName: 'Ford',
      })
    )
    .otherwise(
      always({
        logo: digitalCertificate,
        isOnlineOfferLogoShown: false,
        theme: onlineOfferTheme,
        companyName: 'Digital Certificate',
      })
    );

  const logoImage = (
    <Image
      isLazy
      width="auto"
      height={resultCustomization.logo.height}
      src={resultCustomization.logo.src}
      alt={workspace}
      data-testid="logoImage"
    />
  );

  return {...resultCustomization, logo: logoImage};
}
